import { ContenuPromo } from '@components/contenu-promo/models';
import { Block } from '@shared/models';

export const contenuPromoMock: Block<ContenuPromo> = {
  type: 'contenu-promo',
  data: {},
};
